import { render, staticRenderFns } from "./SbApexChart.vue?vue&type=template&id=e3812040&scoped=true&"
import script from "./SbApexChart.vue?vue&type=script&lang=js&"
export * from "./SbApexChart.vue?vue&type=script&lang=js&"
import style0 from "./SbApexChart.vue?vue&type=style&index=0&id=e3812040&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3812040",
  null
  
)

export default component.exports